/* Copied from prototype/gifts.html by tools/port-page.py. */
/* The scrollbar's width, for the drawing's full bleed (see .gift-art). */
    (function () {
      /* How much of 100vw is scrollbar, measured rather than assumed, David
         30-10-2026: with base.css's scrollbar-gutter: stable, Chrome already
         leaves the gutter out of 100vw, and taking innerWidth - clientWidth
         off again left 7.5px of paper each side of the photograph. The same
         function sits in the section's inline script; keep the two alike. */
      function sbw() {
        var p = document.createElement('div');
        p.style.cssText = 'position:absolute;top:0;left:0;width:100vw;height:0;visibility:hidden';
        document.documentElement.appendChild(p);
        var vw = p.getBoundingClientRect().width;
        p.remove();
        document.documentElement.style.setProperty('--sbw',
          Math.max(0, vw - document.documentElement.clientWidth) + 'px');
      }
      sbw(); window.addEventListener('resize', sbw);
      document.addEventListener('DOMContentLoaded', sbw);
      window.addEventListener('load', sbw);
    })();
  

(function () {
  "use strict";

  /* The bar's cup, as on every other page. */
  var name = 'OKKO';
  try {
    var saved = sessionStorage.getItem('odaka.model');
    if (saved) name = saved;
  } catch (e) {}
  document.getElementById('forms-mark').innerHTML = window.ODAKA_SIL(name);
  document.getElementById('forms-btn').href =
    '/?screen=explore&m=' + window.ODAKA_SLUG(name);

  /* The footer's tally is written by the footer itself (sections/footer.liquid),
     from Shopify, 31-10-2026. */

  /* The drink list, David 28-10-2026: pressed, it unrolls; a drink chosen
     rolls it up and shows that drink's one piece. Keyboard: Enter or Space
     opens, the arrows move, Enter chooses, Escape closes. */
  var pick = document.querySelector('.drink-pick');
  var list = document.getElementById('drink-list');
  if (pick && list) {
    var now = document.getElementById('drink-now');
    var items = Array.prototype.slice.call(list.querySelectorAll('li'));
    var answers = document.querySelectorAll('.drink-answer');

    var open = function (yes) {
      pick.setAttribute('aria-expanded', String(yes));
      list.hidden = !yes;
      if (yes) (list.querySelector('[aria-selected="true"]') || items[0]).focus();
    };
    var choose = function (li, quiet) {
      items.forEach(function (x) { x.setAttribute('aria-selected', String(x === li)); });
      Array.prototype.forEach.call(answers, function (a) {
        a.hidden = a.getAttribute('data-drink') !== li.getAttribute('data-drink');
      });
      now.textContent = li.textContent;
      pick.setAttribute('aria-expanded', 'false');
      list.hidden = true;
      if (!quiet) pick.focus();
    };

    /* Open on a cappuccino, the drink most people buy a cup for, so the box
       shows what it does before anyone presses it. */
    var start = items.filter(function (x) { return x.textContent.trim() === 'Cappuccino'; })[0] || items[0];
    if (start) choose(start, true);

    pick.addEventListener('click', function () { open(list.hidden); });
    items.forEach(function (li) {
      li.addEventListener('click', function () { choose(li); });
      li.addEventListener('keydown', function (e) {
        var i = items.indexOf(li);
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || li).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || li).focus(); }
        else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(li); }
        else if (e.key === 'Escape') { open(false); pick.focus(); }
      });
    });
  }
})();
